$(document).ready(function(){
  $('.accordion-content').hide();
  $('.accordion-title').click(function(){
    // Toggle active class
    $(this).toggleClass('active');
    // Toggle accordion content
    $(this).next('.accordion-content').slideToggle();
  });
  $('header.header .search-field button.search__button').click(function(e){
      e.preventDefault();
  });
  var width = window.innerWidth;
  // if(width < 992){
    var $menuIcon = $('.menu-icon');
    var $mobileMenu = $('.custom-mobile-main-menu');
    $menuIcon.click(() => $mobileMenu.toggleClass('open'));
    $('header.header .custom-mobile-main-menu .mobile-menu .menu-header svg, header.header .custom-mobile-main-menu .backdrop').click(() => $mobileMenu.removeClass('open'));
  // }
  var checkInterval = setInterval(function() {
    if ($('.product .grid__item.product__media-wrapper .custom-media-app-grid div.shopify-block.shopify-app-block').length > 0) {
        $('.product .grid__item.product__media-wrapper .custom-media-app-grid div.shopify-block.shopify-app-block:not(:has(.foxkit-related-products.foxkit-related-products))').remove();
        if(width > 992){
          $('.product .product__info-wrapper div.shopify-block.shopify-app-block:has(foxkit-related-products.foxkit-related-products)').remove();
        } else {
          $('.product .grid__item.product__media-wrapper .custom-media-app-grid .shopify-block.shopify-app-block foxkit-related-products.foxkit-related-products').remove();
        }
        $('.product .shopify-block.shopify-app-block foxkit-related-products.foxkit-related-products .foxkit-related-products__grid .swiper-wrapper.foxkit-hidden').remove();
      if($('.product .shopify-block.shopify-app-block foxkit-related-products.foxkit-related-products .foxkit-related-products__grid foxkit-product-card').length > 4){
        $('.product .shopify-block.shopify-app-block foxkit-related-products.foxkit-related-products .foxkit-related-products__grid').owlCarousel({
          loop: false,
          margin: 10,
          nav: true,
          dots: false,
          responsive:{
            0:{
              items:1
            },
            420:{
              items:2
            },
            768:{
              items:4
            },
            1000:{
              items:3
            },
            1400:{
              items:4
            }
          }
        });
      }
      clearInterval(checkInterval);
    }
  }, 1000);
  
  $(document).on('click', '.card__information .product-details .product-options fieldset.product-form__input--swatch label', function() {
    console.log('Label Click');
    var variantsdata;
    if ($(this).parent().parent().hasClass('owl-item')) {
      variantsdata = JSON.parse($(this).parent().parent().parent().parent().parent().parent().siblings('script').html());
    } else {
      variantsdata = JSON.parse($(this).parent().parent().parent().siblings('script').html());
    }
    var wishlist = $(this).closest('.card__content').siblings('.wishlist-engine');
    setTimeout(function() {
      var options = {};
      var context = this;
      var fieldsets;
      if ($(this).parent().parent().hasClass('owl-item')) {
        fieldsets = $(this).parent().parent().parent().parent().parent().parent().find('fieldset');
      } else {
        fieldsets = $(this).parent().parent().parent().find('fieldset');
      }
      for (var index = 0; index < 3; index++) {
        var fieldset = fieldsets[index];
        var optionElement = null;
        if (fieldset) {
          var optionElement = fieldsets.eq(index).find('input[type="radio"]:checked');
        }
        var option = optionElement ? optionElement.val() : null;
        var i = index + 1;
        options['option' + i] = {
          value: option
        };
      }
      if (!options.option2) {
        options.option2 = { value: null };
      }
      if (!options.option3) {
        options.option3 = { value: null };
      }
      var absolute = variantsdata.filter(function(item) {
        return item.option1 == options.option1.value && item.option2 == options.option2.value && item.option3 == options.option3.value;
      });
      var variantid = absolute.length > 0 ? absolute[0].id : false;
      var variantavailable = absolute.length > 0 ? absolute[0].available : false;
      var variantimage = absolute.length > 0 && absolute[0].featured_image ? absolute[0].featured_image.src : null;
      var variantprice = absolute.length > 0 ? absolute[0].price : false;
      var variantcompareprice = absolute.length > 0 ? absolute[0].compare_at_price : false;
      var nprice = variantprice !== false ? (variantprice / 100).toFixed(0) : '0';
      var ncomapreatprice = variantcompareprice !== false ? (variantcompareprice / 100).toFixed(0) : '0';
      var price = parseFloat(nprice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var comapreatprice = parseFloat(ncomapreatprice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      // console.log(price);
      // console.log(comapreatprice);
      var $currentElement = $(this);
      var $testDiv = null;
      while ($currentElement.length) {
          if ($currentElement.hasClass('product-details')) {
              $testDiv = $currentElement;
              break;
          }
          $currentElement = $currentElement.parent();
      }
      var pricesection = $testDiv.parent().find('.card-information .price');
      
      if (variantid) {
        if ($(this).parent().parent().hasClass('owl-item')) {
          var form = $(this).parent().parent().parent().parent().parent().parent().find('form.form');
        } else {
          var form = $(this).parent().parent().parent().find('form.form');
        }
        form.find('input[name="id"]').val(variantid);
        if (variantimage) {
          var images = form.closest('.card-wrapper').find('.card__inner.gradient .card__media .media img');
          images.each(function() {
            $(this).attr('srcset', '').attr('src', variantimage);
          });
        }
        var addToBagButton = form.find('button[name="Add To bag"]');
        if (!variantavailable) {
          addToBagButton.html('Sold Out').prop('disabled', true);
        } else {
          addToBagButton.html('Add to bag').prop('disabled', false);
        }

        wishlist.attr('data-variant_id', variantid);
        let variantsData = wishlist.attr('data-variants-ids');
        if (variantsData === '') {
          wishlist.attr('data-added', 'false');
          wishlist.find('.wishlist-icon svg path').attr('fill', 'none');
        } else {
          let variants = JSON.parse(variantsData);
        
          if (!variants.includes(Number(variantid))) {
            wishlist.attr('data-added', 'false');
            wishlist.find('.wishlist-icon svg path').attr('fill', 'none');
          } else {
            wishlist.find('.wishlist-icon svg path').attr('fill', '#e4002b');
          }
        }

        if(comapreatprice != null && comapreatprice > price){
          var compareatprice = parseFloat(comapreatprice.replace(/,/g, ''));
          var uprice = parseFloat(price.replace(/,/g, ''));
          var percentageOff = ((compareatprice - uprice) / compareatprice) * 100;
          pricesection.addClass('price--on-sale');
          pricesection.find('.price__container .price__sale span s.price-item.price-item--regular').html('R ' + comapreatprice + ' ZAR');
          pricesection.find('.price__container .price__sale span.price-item.price-item--sale.price-item--last').html('R ' + price + ' ZAR');
          if(pricesection.find('.price__container span.price-item.sale-persentage').length == 0){
            var presentage = $(document.createElement('span'));
            presentage.addClass('price-item sale-persentage');
            pricesection.find('.price__container .price__sale').after(presentage);
          }
          pricesection.find('.price__container span.price-item.sale-persentage').html('Save ' + percentageOff.toFixed(0) + '%');
        } else {
          pricesection.removeClass('price--on-sale');
          pricesection.find('.price__container .price__sale span s.price-item.price-item--regular').html('');
          pricesection.find('.price__container span.price-item.sale-persentage').html('');
          pricesection.find('.price__container .price__regular span.price-item.price-item--regular').html('R ' + price + ' ZAR');
        }
      }
    }.bind(this), 400);
  });

  $(document).on('click', '#ProductGridContainer #product-grid .card-wrapper .wishlist-engine .wishlist-engine-button', function() {
    setTimeout(function(){
      var id = $(this).parent().attr('data-variant_id');
      let variants = JSON.parse($(this).parent().attr('data-variants-ids'));
      // console.log(id + ' > ' + variants);
      if (!variants.includes(Number(id))) {
        variants.push(Number(id));
        // console.log(JSON.stringify(variants));
        $(this).parent().attr('data-variants-ids', JSON.stringify(variants));
      } else {
        variants = variants.filter(variant => variant !== Number(id));
        // console.log(JSON.stringify(variants));
        $(this).parent().attr('data-variants-ids', JSON.stringify(variants));
      }
    }, 800);
  });
  /*$(document).on('change', '.card-wrapper .product-details .product-options .selector-wrapper select', function() {
    var variantsdata = JSON.parse($(this).parent().parent().siblings('script').html());
    setTimeout(function() {
      var options = {};
      var fieldsets = $(this).closest('.product-options').find('fieldset');
      for (var index = 0; index < 3; index++) {
        var optionElement = null;
        if (index < fieldsets.length) {
          var radioElement = fieldsets.eq(index).find('input[type="radio"]:checked');
          var selectElement = fieldsets.eq(index).find('select');
          if (radioElement.length > 0) {
            optionElement = radioElement;
          } else if (selectElement.length > 0) {
            optionElement = selectElement;
          }
        }
        var option = optionElement ? optionElement.val() : null;
        options['option' + (index + 1)] = {
          value: option
        };
      }
      
      if (!options.option2) {
        options.option2 = { value: null };
      }
      if (!options.option3) {
        options.option3 = { value: null };
      }
      
      var absolute = variantsdata.filter(function(item) {
        return item.option1 == options.option1.value && item.option2 == options.option2.value && item.option3 == options.option3.value;
      });
      
      var variantid = absolute.length > 0 ? absolute[0].id : false;
      var variantavailable = absolute.length > 0 ? absolute[0].available : false;
      var variantimage = absolute.length > 0 && absolute[0].featured_image ? absolute[0].featured_image.src : null;
      
      if (variantid) {
        $(this).parent().parent().find('form.form').find('input[name="id"]').val(variantid);
        
        if (variantimage) {
          var images = $(this).closest('.card-wrapper').find('.card__inner.gradient .card__media .media img');
          images.each(function() {
            $(this).attr('srcset', '').attr('src', variantimage);
          });
        }
        
        var addToBagButton = $(this).parent().parent().find('form.form').find('button[name="Add To bag"]');
        if (!variantavailable) {
          addToBagButton.html('Sold Out').prop('disabled', true);
        } else {
          addToBagButton.html('Add to bag').prop('disabled', false);
        }
      }
    }.bind(this), 400);
  });*/

  $(document).on('click', '.card-wrapper .product-details .product-options .selector-wrapper label', function() {
    var variantsdata = JSON.parse($(this).parent().parent().parent().parent().siblings('script').html());
    var wishlist = $(this).closest('.card__content').siblings('.wishlist-engine');
    // console.log(variantsdata);
    setTimeout(function() {
      var options = {};
      var context = this;
      var fieldsets = $(this).parent().parent().parent().parent().find('fieldset');
      for (var index = 0; index < 3; index++) {
        var fieldset = fieldsets[index];
        var optionElement = null;
        if (fieldset) {
          var optionElement = fieldsets.eq(index).find('input[type="radio"]:checked');
        }
        var option = optionElement ? optionElement.val() : null;
        var i = index + 1;
        options['option' + i] = {
          value: option
        };
      }
      if (!options.option2) {
        options.option2 = { value: null };
      }
      if (!options.option3) {
        options.option3 = { value: null };
      }
      var absolute = variantsdata.filter(function(item) {
        return item.option1 == options.option1.value && item.option2 == options.option2.value && item.option3 == options.option3.value;
      });
      var variantid = absolute.length > 0 ? absolute[0].id : false;
      var variantavailable = absolute.length > 0 ? absolute[0].available : false;
      var variantimage = absolute.length > 0 && absolute[0].featured_image ? absolute[0].featured_image.src : null;
      var variantprice = absolute.length > 0 ? absolute[0].price : false;
      var variantcompareprice = absolute.length > 0 ? absolute[0].compare_at_price : false;
      var nprice = variantprice !== false ? (variantprice / 100).toFixed(0) : '0';
      var ncomapreatprice = variantcompareprice !== false ? (variantcompareprice / 100).toFixed(0) : '0';
      var price = parseFloat(nprice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var comapreatprice = parseFloat(ncomapreatprice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var $currentElement = $(this);
      var $testDiv = null;
      while ($currentElement.length) {
          if ($currentElement.hasClass('product-details')) {
              $testDiv = $currentElement;
              break;
          }
          $currentElement = $currentElement.parent();
      }
      var pricesection = $testDiv.parent().find('.card-information .price');

      if (variantid) {
        var form = $(this).parent().parent().parent().parent().find('form.form');
        form.find('input[name="id"]').val(variantid);
        if (variantimage) {
          var images = form.closest('.card-wrapper').find('.card__inner.gradient .card__media .media img');
          images.each(function() {
            $(this).attr('srcset', '').attr('src', variantimage);
          });
        }
        var addToBagButton = form.find('button[name="Add To bag"]');
        if (!variantavailable) {
          addToBagButton.html('Sold Out').prop('disabled', true);
        } else {
          addToBagButton.html('Add to bag').prop('disabled', false);
        }

        wishlist.attr('data-variant_id', variantid);
        let variantsData = wishlist.attr('data-variants-ids');
        if (variantsData === '') {
          wishlist.attr('data-added', 'false');
          wishlist.find('.wishlist-icon svg path').attr('fill', 'none');
        } else {
          let variants = JSON.parse(variantsData);
        
          if (!variants.includes(Number(variantid))) {
            wishlist.attr('data-added', 'false');
            wishlist.find('.wishlist-icon svg path').attr('fill', 'none');
          } else {
            wishlist.find('.wishlist-icon svg path').attr('fill', '#e4002b');
          }
        }
        
        if(comapreatprice != null && comapreatprice > price){
          var compareatprice = parseFloat(comapreatprice.replace(/,/g, ''));
          var uprice = parseFloat(price.replace(/,/g, ''));
          var percentageOff = ((compareatprice - uprice) / compareatprice) * 100;
          pricesection.addClass('price--on-sale');
          pricesection.find('.price__container .price__sale span s.price-item.price-item--regular').html('R ' + comapreatprice + ' ZAR');
          pricesection.find('.price__container .price__sale span.price-item.price-item--sale.price-item--last').html('R ' + price + ' ZAR');
          if(pricesection.find('.price__container span.price-item.sale-persentage').length == 0){
            var presentage = $(document.createElement('span'));
            presentage.addClass('price-item, sale-persentage');
            pricesection.find('.price__container .price__sale').after(presentage);
          }
          pricesection.find('.price__container span.price-item.sale-persentage').html('Save ' + percentageOff.toFixed(0) + '%');
        } else {
          pricesection.removeClass('price--on-sale');
          pricesection.find('.price__container .price__sale span s.price-item.price-item--regular').html('');
          pricesection.find('.price__container span.price-item.sale-persentage').html('');
          pricesection.find('.price__container .price__regular span.price-item.price-item--regular').html('R ' + price + ' ZAR');
        }
      }
    }.bind(this), 400);
    $(this).parent().parent().removeClass('highlight').siblings('legend').removeClass('active-label');
  });



  
  
  // $(document).on('submit', '.card__information .product-details .product-options form[data-type="add-to-cart-form"]', function(e) {
  //   e.preventDefault();
  //   var productId = $(this).find('input[name="id"]').val();
  //   addToCart(productId);
  // });
  
  // function addToCart(productId) {
  //     var data = {
  //         items: [
  //             {
  //                 quantity: 1,
  //                 id: productId
  //             }
  //         ]
  //     };
  
  //     $.ajax({
  //         type: 'POST',
  //         url: '/cart/add.js', // Shopify AJAX endpoint
  //         data: data,
  //         dataType: 'json',
  //         success: function(response) {
  //             // Do something after successfully adding to cart
  //           document.dispatchEvent(new CustomEvent("cart:refresh:opend"));
  //           console.log('Product added to cart!' + response);
  //           location.href = '/cart';
  //         },
  //         error: function(xhr, status, error) {
  //             console.error(error);
  //         }
  //     });
  // }
  
  $(document).on('mouseenter', 'div#ProductGridContainer .collection ul#product-grid li.grid__item .card-wrapper', function() {
    var cardWrapper = $(this);
    if (cardWrapper.find('.item').length > 4) {
      cardWrapper.find('.card__information .product-options fieldset.product-form__input').owlCarousel({
        loop: false,
        margin: 10,
        nav: true,
        dots: false,
        responsive: {
          0: {
            items: 4
          },
          414: {
            items: 4
          },
          425: {
            items: 4
          },
          600: {
            items: 4
          },
          1000: {
            items: 4
          }
        }
      });
    }
  });
  $(document).on('mouseleave', 'div#ProductGridContainer .collection ul#product-grid li.grid__item .card-wrapper', function() {
    $(this).find('.card__information .product-options fieldset.product-form__input').trigger('destroy.owl.carousel');
  });
  
  $('.shopify-section aside#main-collection-filters .facets-container form#FacetFiltersFormMobile div.mobile-facets__main details.mobile-facets__details div.mobile-facets__submenu').each(function(){
    var height = -$(this).height();
    $(this).css('top', height);
  });
    $(document).on('click', '.facets-container .sorting.caption .facet-filters__field:has(.select label) h2.facet-filters__label', function() {
      $(this).parent().toggleClass('open');
    });
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.facets-container .sorting.caption .facet-filters__field:has(.select label).open .select, .facets-container .sorting.caption .facet-filters__field:has(.select label) h2.facet-filters__label').length) {
      $('.facets-container .sorting.caption .facet-filters__field:has(.select label)').removeClass('open');
    }
  });
  $(document).on('click', '.mobile-facets__details .mobile-facets__sort label', function() {
    $(this).parent().find('.select').toggle();
    $(this).toggleClass('active');
  }); 
  $(document).on('click', '.card-wrapper .product-details .product-options .product-option-size fieldset.selector-wrapper legend', function() {
    $(this).parent().siblings().find('legend').removeClass('active-label').siblings('ul').removeClass('highlight');
    $(this).siblings('ul').toggleClass('highlight');
    $(this).toggleClass("active-label");
    $(".card-wrapper .product-details .product-options .product-option-size fieldset.other-custom-fieldset").toggleClass("active-label-main"); 
  });

  $(window).on('scroll', function(){
    $('.facets-container .facets__form .facets__wrapper details.js-filter').each(function(){
      $(this).removeAttr('open');
      $(this).find('summary.facets__summary').attr('aria-expanded', 'false');
    });
  });
  if(window.location.pathname == '/pages/store-locator'){
    if(width > 991){
      var StoreLocatorInterval = setInterval(function() {
        if ($('body[data-template=store-locator] main#MainContent .page-width .container-fluid div#storeifyapps-storelocator-index .map-tab-ggmap.map-tab-mobile.active div#map').length > 0) {
          var height = $('body[data-template=store-locator] main#MainContent .page-width .container-fluid div#storeifyapps-storelocator-index .map-tab-ggmap.map-tab-mobile.active div#map').height();
          $('body[data-template=store-locator] main#MainContent .page-width .container-fluid div#storeifyapps-storelocator-index .storeifyapps-storelocator-equal').css('max-height', height);
          clearInterval(StoreLocatorInterval);
        }
      }, 1000);
      $(document).resize(function(){
        var height = $('body[data-template=store-locator] main#MainContent .page-width .container-fluid div#storeifyapps-storelocator-index .map-tab-ggmap.map-tab-mobile.active div#map').height();
        $('body[data-template=store-locator] main#MainContent .page-width .container-fluid div#storeifyapps-storelocator-index .storeifyapps-storelocator-equal').css('max-height', height);
      })
    }
  }
  if($('body').data('templatename') == 'collection'){
    var intervalId = setInterval(function() {
      if ($('#ProductGridContainer ul#product-grid').length == 0) {
        $('aside#main-collection-filters').hide();
        clearInterval(intervalId);
      }
    }, 500);
  }
  if(window.location.pathname == '/cart'){
    $('.cart__footer-wrapper .cart__ctas .cart__checkout-button').click(function(){
      location.href = '/checkout';
    });
  }

  // Define handleSubmit function globally
  window.handleSubmit = function(form) {
    event.preventDefault();

  var config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  var formData = new FormData(form);
  var CusCartDrawer = document.querySelector('cart-drawer');
  if (CusCartDrawer) {
    formData.append(
      'sections',
      CusCartDrawer.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    CusCartDrawer.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      // console.log(response);
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });
        // Handle error message display or actions here
        // For example: this.handleErrorMessage(response.description);
        return;
      } else if (!CusCartDrawer) {
        window.location = window.routes.cart_url;
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: formData.get('id'),
        cartData: response,
      });

      var quickAddModal = form.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              CusCartDrawer.renderContents(response);
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        CusCartDrawer.renderContents(response);
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      // form.querySelector('.loading__spinner').classList.add('hidden');
      if (CusCartDrawer && CusCartDrawer.classList.contains('is-empty')) {
        CusCartDrawer.classList.remove('is-empty');
      }
    });
  };

  var pdpslider = $('body[data-templatename="product"] main#MainContent .product.product--main_slider.custom_img_slider media-gallery.product__column-sticky slider-component ul.product__media-list');
  if (pdpslider.find('.product__media-item').length > 1) {
    pdpslider.owlCarousel({
      loop: false,
      margin: 10,
      nav: true,
      dots: true,
      items: 1,
      autoHeight:true,
      onInitialized: selectedslide,
      onResized: setOwlStageHeight,
      onTranslated: setOwlStageHeight,
      navText : ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117.84 97.75"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M48.94,97.75,0,48.84,48.87,0l6.64,6.63L18.78,43.34c.18.34.2.42.25.48a.57.57,0,0,0,.18.12.86.86,0,0,0,.23.05h97.63l.23,0a1.68,1.68,0,0,1,.24.06,2.78,2.78,0,0,1,.3.27v9.55h-98a2.6,2.6,0,0,0-.18.43.55.55,0,0,0,0,.22.51.51,0,0,0,.12.2q18,17.94,36,35.83C54.83,92.31,51.3,96,48.94,97.75Z"></path></g></g></svg>','<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117.79 97.83"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M117.79,49.07,69,97.83l-6.75-6.89L99.41,53.8c-1.3-.07-2.11-.15-2.91-.15H0V43.79c8.17-.2,16.37-.06,24.56-.09s16.31,0,24.47,0H98.1a2,2,0,0,0,.15-.36.31.31,0,0,0,0-.22C86.15,31,74.09,18.88,62.18,6.93l7-6.93Z"></path></g></g></svg>'],
      responsive: {
        0: {
          stagePadding: 0
        },
        992: {
          stagePadding: 40
        }
      }
    });
  }
  function setOwlStageHeight(event) {
    // console.log(event);
    setTimeout(function(){
      var maxHeight = 0;
      $('body[data-templatename=product] main#MainContent .product.product--main_slider.custom_img_slider media-gallery.product__column-sticky slider-component ul.product__media-list .owl-stage-outer .owl-stage .owl-item.active').each(function () {
        var thisHeight = parseInt( $(this).find('.product__media-item').height() );
        maxHeight=(maxHeight>=thisHeight?maxHeight:thisHeight);
      });
      // $('.owl-carousel').css('height', maxHeight );
      $('body[data-templatename=product] main#MainContent .product.product--main_slider.custom_img_slider media-gallery.product__column-sticky slider-component ul.product__media-list .owl-stage-outer').css('height', maxHeight );
    }, 500);
  }
  function selectedslide(event) {
    setTimeout(function(){
      $('.product .product__info-wrapper variant-selects fieldset.product-form__input[name="color"] .swatch-input__input:checked+.swatch-input__label').each(function(){
        var img_src = $(this).find('.swatch').attr('style').match(/url\(([^)]+)\)/)[1];
        console.log(img_src);
        $('body[data-templatename=product] main#MainContent .product.product--main_slider.custom_img_slider media-gallery.product__column-sticky slider-component ul.product__media-list .owl-stage-outer .owl-stage .product__modal-opener .product__media img').each(function(){
            var image = $(this).attr('src');
            if(image.includes(img_src)){
                var active_slide = $(this).closest('.owl-item');
                var index = active_slide.index();
                $(".product__media-list").trigger('to.owl.carousel', [index, 300]);
                return false;
            }
        });
      });
    }, 700);
  }

  $('.product .product__info-wrapper variant-selects fieldset.product-form__input[name="color"] label').click(function(){
    var img_src = $(this).find('.swatch').attr('style').match(/url\(([^)]+)\)/)[1];
    $('body[data-templatename=product] main#MainContent .product.product--main_slider.custom_img_slider media-gallery.product__column-sticky slider-component ul.product__media-list .owl-stage-outer .owl-stage .product__modal-opener .product__media img').each(function(){
        var image = $(this).attr('src');
        if(image.includes(img_src)){
            var active_slide = $(this).closest('.owl-item');
            var index = active_slide.index();
            $(".product__media-list").trigger('to.owl.carousel', [index, 300]);
            return false;
        }
    });
  });

  if($('body').data('templatename') == 'product'){
    let payjustnowinterval;
    payjustnowinterval = setInterval(() => {
      var $payjustnow = $('.product .product__info-wrapper product-info.product__info-container #pjn-product-container .pjn-text > p');
      if ($payjustnow.length) {
        var originalText = $payjustnow.html();
        $payjustnow.html('Or Checkout using <b>PayJustNow</b>' + originalText);
        clearInterval(payjustnowinterval);
      }
    }, 500);
    let payflexinterval;
    payflexinterval = setInterval(() => {
      var $payflex = $('.product .product__info-wrapper .product__info-container #partPayCalculatorWidget1 #partPayCalculatorWidgetText');
      if ($payflex.length) {
        var originalText = $payflex.find('.partPayCalculatorWidgetTextFromCopy').html();
          $payflex.find('.partPayCalculatorWidgetTextFromCopy').html(originalText + ' using <b>Playflex</b>');
        clearInterval(payflexinterval);
      }
    }, 500);
  }

  
    // Define the desired order
    var order = ["40MM","43MM","44MM","45MM","48MM","51MM","53MM","57MM","UK 2","UK 2.5","UK 3","UK 3.5","UK 4","UK 4.5","UK 5","UK 5.5","UK 6","UK 6.5","UK 7","UK 7.5","UK 8","UK 8.5","UK 9","UK 9.5","UK 10","UK 10.5","UK 11","UK 11.5","UK 12","UK 12.5","XXS","XS","S","S-M","S/M","M","L","L-XL","L/XL","XL","XXL","2XL","3XL","4XL","5XL","One Size","OSFA","OSFM","1","1.5","2","2.5","3","3.5","4","4.5","5","5.5","6","6.5","7","7.5","8","8.5","9","9.5","10","10.5","11","11.5","12","12.5","13","13.5","14","14.5","15","15.5","16","16.5","17","17.5","18","18.5","19","19.5","20","20.5","21","21.5","22","22.5","23","23.5","24","24.5","25","25.5","26","26.5","27","27.5","28","28.5","29","29.5","30","30.5","31","31.5","32","32.5","33","33.5","34","34.5","35","35.5","36","36.5","37","37.5","38","38.5","39","39.5","40","40.5","41","41.5","42","42.5","43","43.5","44","44.5","45","45.5","46","46.5","47","47.5","48","48.5","49","49.5","50","50.5","51","51.5","52","52.5","53","53.5","54","54.5","55","55.5","56","56.5","57","57.5","58","58.5","59","59.5","60","60.5","75","80","85","90","95","100","105","405","445"];

    function sizeoptionsorting() {
      // Get all the UL elements with the specific class
      var ulElements = document.querySelectorAll('.card-wrapper .product-details .product-options .product-option-size fieldset.selector-wrapper ul'); // Replace 'class-name' with the actual class name
    
      ulElements.forEach(ul => {
          // Get all LI elements inside the UL
          var liElements = Array.from(ul.querySelectorAll('li'));
    
          // Sort LI elements based on the input value according to the desired order
          liElements.sort((a, b) => {
              var aValue = a.querySelector('input').value;
              var bValue = b.querySelector('input').value;
              return order.indexOf(aValue) - order.indexOf(bValue);
          });
    
          // Clear the UL
          ul.innerHTML = '';
    
          // Append the sorted LI elements back to the UL
          liElements.forEach(li => ul.appendChild(li));
      });
    }
    sizeoptionsorting();
    $(document).on('change', '.facets-container facet-filters-form label, .facets-container facet-filters-form input',function(){
      setTimeout(function(){
        // console.log('sorting');
        sizeoptionsorting();
      }, 1500);
    });
    $(document).on('click', 'body[data-templatename="collection"] facet-remove.active-facets__button-wrapper',function(){
      setTimeout(function(){
        // console.log('sorting removed');
        sizeoptionsorting();
      }, 1500);
    });

    function sortElements(parent, orderArray, selector) {
          var elements = Array.from(parent.querySelectorAll(selector));
          elements.sort((a, b) => {
              var aValue = a.querySelector('input').value;
              var bValue = b.querySelector('input').value;
              return orderArray.indexOf(aValue) - orderArray.indexOf(bValue);
          });
  
          parent.innerHTML = '';
          elements.forEach(element => parent.appendChild(element));
      }
  
      // Sorting divs inside owl-stage
      var owlStage = document.querySelector('.product__info-wrapper .product__info-container variant-selects .product-form__input--pill.size .owl-stage');
      if (owlStage) {
          sortElements(owlStage, order, '.owl-item');
      }

  
    // Define the desired order
    // var order = ["40MM","43MM","44MM","45MM","48MM","51MM","53MM","57MM","UK 10","UK 10.5","UK 11","UK 11.5","UK 12","UK 2.5","UK 3","UK 3.5","UK 4","UK 4.5","UK 5","UK 6","UK 6.5","UK 7","UK 7.5","UK 8","UK 8.5","UK 9","UK 9.5","XXS","XS","S","S-M","S/M","M","L","L-XL","L/XL","XL","XXL","2XL","3XL","4XL","5XL","One Size","OSFA","OSFM","1","2","3","4","5","6","7","8","9","10","10K","11","11.5","12","13","13-Oct","14","16","23","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","42","43","44","45","46","48","50","52","54","75","80","85","90","95","100","105","405","445"];

    // Function to sort and reorder child elements
    function sortElements1(parent, orderArray, selector) {
        var elements1 = Array.from(parent.querySelectorAll(selector));
        elements1.sort((a, b) => {
            var aValue = a.querySelector('input').value;
            var bValue = b.querySelector('input').value;
            return orderArray.indexOf(aValue) - orderArray.indexOf(bValue);
        });

        parent.innerHTML = '';
        elements1.forEach(element => parent.appendChild(element));
    }

    // Sorting divs inside custom-option-group
    var customOptionGroups = document.querySelectorAll('.product__info-wrapper .product__info-container variant-selects .product-form__input--pill.size .custom-option-group:not(.owl-loaded)');
    customOptionGroups.forEach(group => {
        sortElements1(group, order, '.custom-box-option');
    });

  if($('body').data('templatename') == 'product'){
     $('.product .product__info-wrapper variant-selects fieldset.product-form__input label').click(function() {
      setTimeout(function() {
        var selectvari = $(this).closest('variant-selects').siblings('div:has(product-form.product-form)').find('input.product-variant-id').val();
        // console.log(selectvari);
        updateGemcodeDisplay(selectvari);      
      }.bind(this), 400);
    });
    function updateGemcodeDisplay(variantId) {
      var gemcode = '';
      for (var i = 0; i < gemcodeArray.length; i++) {
        if (gemcodeArray[i].id == variantId) {
          gemcode = gemcodeArray[i].gemcode;
          break;
        }
      }
      // console.log(gemcode);
      $('body[data-templatename="product"] .product__info-wrapper product-info.product__info-container .gemcode').html(gemcode);
    }
  
    var selectvari = $('.product .product__info-wrapper div:has(product-form.product-form) input.product-variant-id').val();
    // console.log(selectvari);
    updateGemcodeDisplay(selectvari);

    $('.product__info-wrapper product-info .swatch-input__label').click(function(){
      $('.product__info-wrapper product-info .swatch-input__label .sale_badge').remove();
      var variantsdata = JSON.parse($('variant-selects').find('[type="application/json"]').text());
      var label = $(this);
      var value = $(this).siblings('input').val();
      var fieldset = $(this).closest('fieldset');
      var options = variantsdata.filter(function(item) {
        return item.option2 == value;
      });
      var otherfieldset = fieldset.siblings('fieldset');    
      otherfieldset.find('input:checked').each(function() {
        var option_value = $(this).val();
        var match = options.some(function(option) {
          return option.option1 == option_value && option.compare_at_price != null;
        });
      
        if (match) {
          if(!label.find('.sale_badge_color').length){
            var saleBadge = $('<span class="sale_badge">sale</span>');
            label.find('.swatch').after(saleBadge);
          }
        } else {
          if (label.find('.sale_badge').length > 0) {
            label.find('.sale_badge').remove();
          }
        }
      });
    });

    $('.product__info-wrapper product-info .swatch-input__label').each(function(){
      var variantsdata = JSON.parse($('variant-selects').find('[type="application/json"]').text());
      var label = $(this);
      var value = $(this).siblings('input').val();
      var fieldset = $(this).closest('fieldset');
      var options = variantsdata.filter(function(item) {
          return item.option2 == value;
      });
      var match = options.filter(function(option) {
        return option.compare_at_price != null;
      });
    
      if (options.length == match.length) {
         var saleBadge = $('<span class="sale_badge_color">sale</span>');
        label.find('.swatch').after(saleBadge);
      }
    });

    
    $('.custom-media-product-block .custom-media-varient-list .item input').each(function(){
      var fieldset = $(this).closest('fieldset');
      var variantsdata = JSON.parse($('variant-selects').find('[type="application/json"]').text());
      var option = $(this).val();
      
      // console.log("Selected option: ", selectoption);
      
      var options = variantsdata.filter(function(item) {
        return item.option2 == option && item.available == true;
      });
      if(options.length == 0){
        $(this).addClass('no_sizes');
      }
      if($(this).prop('checked') == true){
        var otherfieldset = fieldset.siblings('fieldset');
        otherfieldset.find('input').each(function(){
          var value = $(this).val();
          var match = options.some(function(option) {
            return option.option1 == value;
          });
  
          if (match) {
            $(this).removeClass('disabled');
          } else {
            $(this).addClass('disabled');
          }
        });
        var allDisabled = otherfieldset.find('.custom-option-group.owl-loaded .custom-box-option input').length === otherfieldset.find('.custom-option-group.owl-loaded .custom-box-option input.disabled').length;
        if (allDisabled) {
          otherfieldset.find('.custom-option-group.owl-loaded').addClass('no_visible_size');
        } else {
          if(otherfieldset.find('.custom-option-group.owl-loaded').hasClass('no_visible_size')){
            otherfieldset.find('.custom-option-group.owl-loaded').addClass('no_visible_size');
          }
        }
      }
    });
    
    $(document).on('click', '.custom-media-product-block .custom-media-varient-list .item label', function() {
      var fieldset = $(this).closest('fieldset');
      var variantsdata = JSON.parse($('variant-selects').find('[type="application/json"]').text());
      var selectoption = $(this).siblings('input').val();

      var options = variantsdata.filter(function(item) {
        return item.option2 == selectoption;
      });
  
      var otherfieldset = fieldset.siblings('fieldset');
      var firstMatchFound = false;
      var checkedMatchExists = false;

      otherfieldset.find('input:checked').each(function() {
          var value = $(this).val();
          var match = options.some(function(option) {
            return option.option1 == value && option.available == true;
          });
  
          if (match) {
            checkedMatchExists = true;
            return false;
          }
      });
      
      otherfieldset.find('input').each(function() {
        var value = $(this).val();
        var match = options.some(function(option) {
          return option.option1 == value && option.available == true;
        });

        if (match) {
          $(this).removeClass('disabled');
          if (!checkedMatchExists && !firstMatchFound) {
            $(this).prop('checked', true);
            firstMatchFound = true;
            $('.product-form__input--pill .custom-option-group.owl-loaded  ').trigger('to.owl.carousel', [0, 300]);
          }
        } else {
          $(this).addClass('disabled');
          if (!checkedMatchExists) {
            $(this).prop('checked', false);
          }
        }
      });
      var allDisabled = otherfieldset.find('.custom-option-group.owl-loaded .custom-box-option input').length === otherfieldset.find('.custom-option-group.owl-loaded .custom-box-option input.disabled').length;
      if (allDisabled) {
        otherfieldset.find('.custom-option-group.owl-loaded').addClass('no_visible_size');
      } else {
        if(otherfieldset.find('.custom-option-group.owl-loaded').hasClass('no_visible_size')){
          otherfieldset.find('.custom-option-group.owl-loaded').addClass('no_visible_size');
        }
      }
    });
    
  }
});

$('.facets-container .sorting.caption .facet-filters__field:has(.select label) .select label').click(function(){
   //location.href = '/account'; 
    $('.facet-filters__field.open').each(function() {
       $(this).removeClass('open');
    });
});



var homeslider = $('slider-component.slider-mobile-gutter .product-grid');
  if (homeslider.find('.grid__item').length > 1) {
    homeslider.owlCarousel({
      loop: false,
      margin: 10,
      nav: true,
      dots: false,
      navText : ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117.84 97.75"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M48.94,97.75,0,48.84,48.87,0l6.64,6.63L18.78,43.34c.18.34.2.42.25.48a.57.57,0,0,0,.18.12.86.86,0,0,0,.23.05h97.63l.23,0a1.68,1.68,0,0,1,.24.06,2.78,2.78,0,0,1,.3.27v9.55h-98a2.6,2.6,0,0,0-.18.43.55.55,0,0,0,0,.22.51.51,0,0,0,.12.2q18,17.94,36,35.83C54.83,92.31,51.3,96,48.94,97.75Z"></path></g></g></svg>','<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117.79 97.83"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M117.79,49.07,69,97.83l-6.75-6.89L99.41,53.8c-1.3-.07-2.11-.15-2.91-.15H0V43.79c8.17-.2,16.37-.06,24.56-.09s16.31,0,24.47,0H98.1a2,2,0,0,0,.15-.36.31.31,0,0,0,0-.22C86.15,31,74.09,18.88,62.18,6.93l7-6.93Z"></path></g></g></svg>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 3
        },
        1200: {
          items: 4
        }
      }
    });
  }